import type { RelationalOrJsonEntityFilter } from "@shared/helpers/sql-relations";
import { Filter, repo, type ClassType, type EntityFilter } from "remult";
import { getHyperEntityConfig } from "../hyper-entity.decorator";
import { preProcessFilterPerRoles } from "./preprocess-filter-for-role";

export async function copyApiPrefilterPerRole<Entity>(
  entity: ClassType<Entity>,
  baseFilter: EntityFilter<Entity> = {},
) {
  const { apiPrefilterPerRole } = getHyperEntityConfig(entity);

  if (!apiPrefilterPerRole) return {};

  const metadata = repo(entity).metadata;

  return (await preProcessFilterPerRoles(apiPrefilterPerRole, {
    disableDevelopmentSecurityLogger: true,
  })(baseFilter, {
    metadata,
    async getFilterPreciseValues(filter) {
      return await Filter.getPreciseValues(metadata, filter ?? {});
    },
  })) as Promise<EntityFilter<Entity> & RelationalOrJsonEntityFilter<Entity>>;
}
